import defaultSettings from '@/settings'

const title = defaultSettings.title || '广元凤台国际酒店'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
